module.exports = __webpack_public_path__ + "static/media/avast-vince-martian.6306b9ef.jpg";